export type PortfolioProductIdMapEntry = {
  is_portfolio_holding?: boolean;
};

export type PortfolioProductIdMap = Record<
  string,
  PortfolioProductIdMapEntry
>;

/** True when metadata maps include at least one nested portfolio holding. */
export function hasNestedPortfolioHoldingsInMaps(
  productMaps: PortfolioProductIdMap
): boolean {
  return Object.values(productMaps).some((info) => info.is_portfolio_holding);
}

/** Detect nested portfolio holdings from widget maps and/or transformed rows. */
export function hasNestedPortfolioHoldings(
  productMaps: PortfolioProductIdMap,
  holdings: { is_portfolio_holding?: boolean }[]
): boolean {
  return (
    hasNestedPortfolioHoldingsInMaps(productMaps) ||
    holdings.some((holding) => holding.is_portfolio_holding)
  );
}
